/**
 * Contains constants for universe user types
 */
module.exports = {
  CUSTOMER: "C",
  AGENT: "A",
  UNIVERSE: "U",
  GUEST: "G",
  RECEIVER: "R",
  GUEST_SENDER: "O",
  APP_SHIPPER: "S",
};
